// --------------------------------------------------------------
// Created On: 2021-10-06
// Author: Zachary Thomas
//
// Last Modified: 2026-10-01
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A hamburger menu button for opening up a navigation drawer.
export default function HamburgerButton(props: Props): Component {
  return (
    <button type="button" className={`btn btn-secondary d-inline-block d-xl-none me-2 py-0`} style={{ height: "40px" }} onClick={() => props.onClick()}>
      <i className="fa fa-fw fa-bars fa-1x d-inline d-sm-none" data-test="hamburger-menu-button-small" />
      <i className="fa fa-fw fa-bars fa-2x d-none d-sm-inline" data-test="hamburger-menu-button-large" />
    </button>
  );
}

interface Props {
  onClick: () => void;
}
